export default __webpack_public_path__ + "static/media/icon-diferencial.3336bb58.svg";